export const ANNUAL_TURNOVER_OPTIONS = [
  '0-50000',
  '50000-100000',
  '100000-200000',
  '200000-500000',
  '500000-1000000',
  '1000000-2000000',
  '2000000-5000000',
  '5000000-10000000',
  '10000000-50000000',
  '50000000-',
] as const;

export const YEARLY_TRANSACTION_VOLUME_OPTIONS = [
  '0-10000',
  '10000-50000',
  '50000-100000',
  '100000-500000',
  '500000-',
] as const;

export const NET_EQUITY_RANGES = [
  '0-25k',
  '25k-50k',
  '50k-75k',
  '75k-100k',
  '100k-150k',
  '150k-200k',
  '200k-250k',
  '250k-500k',
  '500k-',
] as const;
export type NetEquityRange = (typeof NET_EQUITY_RANGES)[number];

export const NET_INCOME_RANGES = [
  '0-25k',
  '25k-50k',
  '50k-75k',
  '75k-100k',
  '100k-150k',
  '150k-200k',
  '200k-250k',
  '250k-500k',
  '500k-',
] as const;
export type NetIncomeRange = (typeof NET_INCOME_RANGES)[number];

export const SHARE_CAPITAL_RANGES = [
  '0-25k',
  '25k-50k',
  '50k-75k',
  '75k-100k',
  '100k-150k',
  '150k-200k',
  '200k-250k',
  '250k-500k',
  '500k-',
] as const;
export type ShareCapitalRange = (typeof SHARE_CAPITAL_RANGES)[number];

export const SHARE_CAPITAL_ORIGIN_OPTIONS = [
  'personal_funds_of_the_founders',
  'funds_from_family_and_friends',
  'business_angels_or_private_investors',
  'venture_capital_or_investment_funds',
  'corporate_investors',
  'bank_loan_or_other_credit_facility',
  'grants_or_public_funding',
  'other',
] as const;
export type ShareCapitalOrigin = (typeof SHARE_CAPITAL_ORIGIN_OPTIONS)[number];
